import {
  InspectionAlarmtCase,
  InspectionAlarmtCaseDto,
  InspectionCase
} from '../../inspection-cases';

export class AlarmCheckDto extends InspectionCase {
  hubLocation?: string;
  hubModel?: string;
  serialNumber?: string;
  dialer?: string;
  addToReport?: boolean = true;
  alarms?: InspectionAlarmtCaseDto[];
}

export class AlarmCheck extends AlarmCheckDto {
  constructor(
    data: AlarmCheckDto = {
      title: 'בדיקת התרעות'
    }
  ) {
    super(data);
    this.hubLocation = data.hubLocation;
    this.hubModel = data.hubModel;
    this.serialNumber = data.serialNumber;
    this.dialer = data.dialer;
    this.addToReport = data.addToReport;
    this.alarms = data.alarms
      ? data.alarms.map((item) => new InspectionAlarmtCase(item))
      : [new InspectionAlarmtCase()];
  }

  // setInspectionStatus(): void {
  //   this.isPassed = !this.isApplicable || this.isPassed; // this._isAlarmsPassed();
  // }

  // private _isAlarmsPassed(): boolean {
  //   return !this.alarms.some((alarm) => alarm.isApplicable && !alarm.isPassed);
  // }
}
